<div class="card section">
  <div class="card-body">
    <div class="row">
      <div class="col-1 pt-2">
        <h6>{{ number ?? "#" }}</h6>
      </div>
      <div class="col-9 pl-0 pt-2 checklist-radio-content">
        <mat-label
          *ngIf="radioQuestion"
          [innerHTML]="labelHtml | placeholderHighlight: editor"
        ></mat-label>
        <div class="d-flex justify-content-start">
          <div class="ml-0">
            <fieldset
              class="field-group"
              [ngClass]="{ 'border-none': !radioQuestion }"
            >
              <legend *ngIf="radioQuestion">
                <span
                  [innerHTML]="radioQuestion | placeholderHighlight: editor"
                ></span>
              </legend>
              <legend *ngIf="!radioQuestion && question">
                <span
                  [innerHTML]="labelHtml | placeholderHighlight: editor"
                ></span>
              </legend>

              <mat-radio-group
                class="radio-options"
                [value]="radioSelection"
                [disabled]="disabled || checked || radioDisabled"
                [ngClass]="{
                  'radio-options-inline': !radioQuestion,
                  'radio-options-with-corner-no':
                    radioQuestion && hasCornerNoOption(),
                }"
              >
                <mat-radio-button
                  class="radio-option"
                  [ngClass]="{
                    'radio-option-no': radioQuestion && isNoOption(r),
                  }"
                  *ngFor="let r of radioOptions"
                  [checked]="r.checked"
                  [value]="r.value"
                  (change)="radioChange($event)"
                >
                  <div class="radio-option-content">
                    <span
                      class="radio-label"
                      [innerHTML]="r.label | placeholderHighlight: editor"
                    ></span>

                    <document-chips
                      *ngIf="r.radSurveyRequiredForms?.length"
                      [documentChips]="r.radSurveyRequiredForms"
                      [isRadSurvey]="true"
                      [staticDisplay]="isStaticRadSurveyDisplay()"
                    >
                    </document-chips>
                  </div>
                </mat-radio-button>
              </mat-radio-group>
            </fieldset>
          </div>
        </div>
      </div>

      <div class="col-2 d-flex justify-content-end align-items-start">
        <div *ngIf="checkboxVisible" class="d-flex flex-row align-items-center">
          <mat-checkbox-with-roles
            [labelPosition]="'before'"
            [checked]="checked"
            [disabled]="!checkboxEnabled()"
            (change)="checkboxChanged($event)"
            [color]="color"
            [roleCodes]="roleCodes"
            [warning]="moreInfo"
            [cautionWarning]="locationMoreInfo ?? ''"
            [user]="user"
            [date]="date"
          >
          </mat-checkbox-with-roles>
        </div>
      </div>
    </div>
  </div>
</div>
